"use strict";
import { useEffect, useState } from "react";
import { logger } from "utilities/src/logger/logger";
export function useDeferredComponent(importFn) {
  const [Component, setComponent] = useState(null);
  useEffect(() => {
    if ("requestIdleCallback" in window) {
      requestIdleCallback(
        async () => {
          try {
            const mod = await importFn();
            setComponent(() => mod.default);
          } catch (error) {
            logger.error(error, {
              tags: {
                file: "useDeferredComponent.tsx",
                function: "requestIdleCallback"
              }
            });
          }
        },
        { timeout: 100 }
      );
    } else {
      setTimeout(async () => {
        try {
          const mod = await importFn();
          setComponent(() => mod.default);
        } catch (error) {
          logger.error(error, {
            tags: {
              file: "useDeferredComponent.tsx",
              function: "setTimeout"
            }
          });
        }
      }, 1);
    }
  }, []);
  return Component;
}
